<template>
  <div>
    <div class="card-header d-flex justify-content-between">
      <h6 class="lh-5 mg-b-0">Миний номууд</h6>
      <b-pagination
        v-if="allCount > 0"
        class="mg-r-20"
        size="sm"
        align="center"
        v-model="pager.page"
        :total-rows="allCount"
        :per-page="pager.size"
        @change="pageChanged"
        style="margin-bottom: 0"
      ></b-pagination>
    </div>
    <div class="card-body pd-x-0 pd-y-10">
      <vue-custom-scrollbar :style="`height: ${getScrollHeight(195)}`">
        <lib-items
          :tasks="tasks"
          @on-cancel-order="cancelOrderConfirm"
          @on-item-modal="onItemModal"
        />
      </vue-custom-scrollbar>
    </div>
    <b-overlay :show="overlayObj.busy" no-wrap>
      <template #overlay>
        <div
          v-if="overlayObj.processing"
          class="text-center p-4 bg-secondary text-light rounded"
        >
          <b-icon icon="info" font-scale="4"></b-icon>
          <div class="mb-3">Түр хүлээнэ үү...</div>
          <b-progress
            min="1"
            max="20"
            :value="18"
            variant="warning"
            height="5px"
            class="mx-n4 rounded-0"
          ></b-progress>
        </div>
        <div
          v-else
          ref="dialog"
          tabindex="-1"
          role="dialog"
          aria-modal="false"
          aria-labelledby="form-confirm-label"
          class="text-center p-3"
        >
          <p><strong id="form-confirm-label">Итгэлтэй байна уу?</strong></p>
          <div class="d-flex">
            <b-button
              variant="outline-danger"
              class="mr-3"
              @click="overlayObj.busy = false"
            >
              Үгүй
            </b-button>
            <b-button variant="outline-success" @click="overlayPost()"
              >Тийм</b-button
            >
          </div>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import vueCustomScrollbar from "vue-custom-scrollbar";
import { request } from "@/api/all";

export default {
  components: {
    vueCustomScrollbar,
    libItems: () => ({
      component: import(
        "@/views/modules/lms/student/pages/library/components/items.vue"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  data() {
    return {
        statObj: {
        data: {},
        rdy: false,
      },
      overlayObj: {
        processing: false,
        busy: false,
        processingId: 0,
      },
      tasks: [],
      nowDate: "",
      allCount: "",
      pager: {
        page: 1,
        size: 10,
      },
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    pageChanged(e) {
      this.pager.page = e;
      this.init();
    },
    init() {
      request({
        api: { method: "POST", url: "TaskCore/GetCoreList" },
        data: {
          skip: 0,
          size: 100,
          ot: 504,
          model: {
            i1: 1,
            secondUserId: this.$store.state.user.userId,
          },
        },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.nowDate = res.data.nowDate;
          this.allCount = res.data.allCount;
          this.tasks = res.data.tasks;
        }
      });
    },
    initStat() {
      request({
        api: { method: "GET", url: "library/MyDashboard" },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.statObj.data = res.data.stat;
          this.statObj.rdy = true;
        }
      });
    },
    overlayPost() {
      this.overlayObj.processing = true;
      let url = "library/DeclineOrder";
        if (this.$route.params.m == 4) {
          url = "library/DeclineOrder";
        }
      request({
        data: {
          id: this.overlayObj.processingId,
        },
        api: { url: url, method: "POST" },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.overlayObj.busy = false;
          this.overlayObj.processing = false;
          this.tasks = [];
          this.init();
          this.initStat();
        }
      });
    },
    cancelOrderConfirm(e) {
      this.overlayObj.processingId = e.id;
      this.overlayObj.busy = true;
    },
    getScrollHeight(mv) {
      let mh = 120;
      if (screen.width <= 1024) {
        mh = 85;
      }

      if (mv != undefined) {
        mh = mv;
      }

      return `calc(${window.innerHeight}px - ${mh}px) !important;`;
    },
  },
};
</script>
